<div (click)="toggleOpen()">
    <ng-content select="[ops-accordion-header]"></ng-content>
</div>

<div #contentContainer class="accordion-content" [ngStyle]="contentStyle">
    <div #content>
        <ng-content select="[ops-accordion-content]"></ng-content>
    </div>
</div>
